import React from "react";
import { Routes, Route } from "react-router-dom";
import { LocationProvider } from "./context/LocationContext";

import Home from "./pages/Home";
import LoginPage from "./pages/Login";
import SignupPage from "./pages/Signup";
import UserComplaint from "./pages/UserComplaint";
import UserComplaintStatus from "./pages/UserComplaintStatus";
import DashboardPage from "./pages/UserDashboard";
import DriverDashboardPage from "./pages/DriverDashboard";
import TaskAssign from "./pages/TaskAssign";
import GuestComplaint from "./pages/Guest";
import AdminDashboardPage from "./pages/AdminDashboard";
import GenerateAnalyticsPage from "./pages/GenerateAnalytics";
import ComplaintControlPage from "./pages/ComplaintControl";
import RecyclingDashboardPage from "./pages/RecyclingDashboard";
import RecyclingCollectionsPage from "./pages/RecyclingCollections";
import RecyclingDetectionsPage from "./pages/RecyclingDetections";
import RecyclingNotificationsPage from "./pages/RecyclingNotifications";
import RecyclingControlPage from "./pages/RecyclingControl";



function App() {
  return (
    <LocationProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/report-complaint" element={<GuestComplaint />} />
        <Route path="/user/add-complaint" element={<UserComplaint />} />
        <Route path="/user/complaint-status" element={<UserComplaintStatus />} />
        <Route path="/user/user-dashboard" element={<DashboardPage />} />
        <Route path="/driver/driver-dashboard" element={<DriverDashboardPage />} />
        <Route path="/driver/task-assign" element={<TaskAssign />} />
        <Route path="/recycling/dashboard" element={<RecyclingDashboardPage />} />
        <Route path="/recycling/detections" element={<RecyclingDetectionsPage />} />
        <Route path="/recycling/notifications" element={<RecyclingNotificationsPage />} />
        <Route path="/recycling/collections" element={<RecyclingCollectionsPage />} />
        <Route path="/admin/admin-dashboard" element={<AdminDashboardPage />} />
        <Route path="/admin/generate-analytics" element={<GenerateAnalyticsPage />} />
        <Route path="/admin/recycling-control" element={<RecyclingControlPage />} />
        <Route path="/admin/complaint-control" element={<ComplaintControlPage />} />

      </Routes>
    </LocationProvider>
  );
}

export default App;
